import React from "react";
import { Navigate } from "react-router-dom";

// Legacy /admin/cobros route now redirects to the unified Finanzas module.
export default function PaymentsPage() {
  return <Navigate to="/admin/finanzas" replace />;
}
